import React from 'react'
import { Controller } from 'react-hook-form'
import AsyncSelect from 'react-select/async';

const CustomAsyncSelect = ({
    name,
    control,
    loadOptions,
    placeholder,
    rules,
    getOptionLabel = (option) => option.label,
    getOptionValue = (option) => option.value
}) => {
  return (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState}) => (
            <>
                <AsyncSelect
                    cacheOptions
                    loadOptions={loadOptions}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder={placeholder}
                    getOptionLabel={getOptionLabel}
                    getOptionValue={getOptionValue}
                    className={`react-select ${fieldState.invalid ? 'is-invalid' : ''}`}
                />
                {fieldState.invalid && (
                    <div className="invalid-feedback">{fieldState.error?.message}</div>
                )}
            </>
        )}
    />
  )
}

export default CustomAsyncSelect